import React from 'react';

import { Redirect } from 'react-router-dom';

class PrivateRoute extends React.Component {
    getAuthentication = () => {
        return sessionStorage.getItem('status')
    }

    render() {
        const Component = this.props.component
        const isAuthenticated = this.getAuthentication();

        return isAuthenticated ? (
            <Component />
        )
        :
        (
            <Redirect to={{ pathname: '/Login' }} />
        )
    }
}

export default PrivateRoute;